import React from "react"
import { Box, Container, Text, Flex, Heading, Grid } from "theme-ui"
import { InboundLink } from "./link"
import { getPagePath } from "../utils/path"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { motion } from "framer-motion"

import VideoStream from "./VideoStream"

const PageCardCollection = ({ block }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale
  const { page } = block

  return (
    <Container sx={{ mt: [3, 5, 6, 6] }}>
      <Grid
        columns={[1, 2, 3]}
        sx={{
          gap: [2, 3, 4, 4],
          a: {
            textDecoration: "none",
          },
        }}
      >
        {page.map((page, index) => (
          <InboundLink to={getPagePath(page, locale)} key={index}>
            <PageCard key={index} page={page} />
          </InboundLink>
        ))}
      </Grid>
    </Container>
  )
}

const PageCard = ({ page }) => {
  const { title, heroImage } = page

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ ease: "easeInOut", duration: 0.2 }}
    >
      <Box
        sx={{
          borderRadius: "80px",
          overflow: "hidden",
          display: "flex",
        }}
      >
        <VideoStream
          muxPlaybackId={heroImage.video.muxPlaybackId}
          // customData={heroImage.customData}
          aspectRatio={"1/1"}
          // sx={{
          //   width: "100%",
          //   height: "100%",
          //   zIndex: 1,
          //   transform: "translate(-50%, -50%)",
          // }}
        />
      </Box>
      <Box sx={{ my: 4 }}>
        <Heading
          sx={{
            mt: [2, 2, 3],
            fontSize: 1,
            fontFamily: "mono",
            textAlign: "center",
            textTransform: "uppercase",
            color: "dark",
            fontWeight: 600,
          }}
        >
          {title}
        </Heading>
      </Box>
    </motion.div>
  )
}

export default PageCardCollection
